import { anmClassificationCatalogEnUS } from "./anm-classification/en-US";
import { inspectionEnUS } from "./inspection/en-US";
import { regionalClassificationCatalogEnUS } from "./regional-classification/en-US";

export const enUS = {
  inspection: inspectionEnUS,
  test: "If you see this, i18next is working!",
  operationalPermissions: {
    keys: {
      view: "View",
      create: "Create",
      update: "Edit",
      delete: "Delete",
      upload: "Upload",
      download: "Download",
    },
  },
  operationalModules: {
    selector: {
      title: "Select a structure",
      empty: "No structures available for this module.",
    },
    placeholder: {
      underConstruction: "This module is under construction.",
    },
  },
  general: {
    comingSoon: {
      title: "Coming soon",
      description:
        "This structure type does not have a dashboard in the General module yet.",
    },
    dashboard: {
      emptyValue: "—",
      loadError: "Error loading data.",
      button: {
        close: "Close",
      },
      pagination: {
        showing: "Page {{current}} of {{total}}",
        previous: "Previous",
        next: "Next",
      },
      anmClassification: {
        title: "ANM Classification",
        modalTitle: "ANM Classification Sheet",
        dpa: "Associated Potential Damage",
        cri: "Risk Classification",
        go: "Operational Management",
        sections: {
          ct: "Technical Characteristics",
          ec: "Conservation Status",
          psb: "Safety Plan",
          dpa: "Associated Potential Damage",
          go: "Operational Management",
        },
      },
      regionalClassification: {
        title: "Regional Classification",
        modalTitle: "Regional Classification Sheet",
        dpa: "Associated Potential Damage",
        cri: "Risk Classification",
        state: "State:",
        norm: "Norm:",
        selectionsTitle: "Regional Norm Selections",
      },
      classificationDetail: {
        resultTitle: "Classification result",
        criteriaTitle: "Criteria breakdown",
        subtotal: "Subtotal",
      },
      generalData: {
        title: "General Data",
        modalTitle: "General Data Sheet",
        responsibleCompany: "Responsible company",
        operationStartDate: "Operation start date",
        operationEndDate: "Operation end date",
        coordinateSystem: "Coordinate system",
      },
      tenantSummary: {
        title: "GS3 / Client",
        modalTitle: "Client Sheet",
        logoAlt: "Client logo",
        clientName: "Client",
        fantasyName: "Trade Name",
        cnpj: "CNPJ",
        cep: "ZIP Code",
        responsibleName: "Responsible",
      },
      complex: {
        title: "Complex",
        modalTitle: "Complex Sheet",
        name: "Complex",
        cnpj: "CNPJ",
        cep: "ZIP Code",
        responsibleName: "Responsible",
      },
      hydrology: {
        title: "Hydrology",
      },
      raisingHistory: {
        title: "Raising History",
        modalTitle: "Raising History",
      },
      geometry: {
        title: "Mass Geometry",
        modalTitle: "Geometry Sheet",
      },
      reservoirManagement: {
        title: "Reservoir Management",
        modalTitle: "Reservoir Management",
      },
      riskMapping: {
        title: "Risk Mapping",
      },
      map: {
        title: "Map",
        noCoordinates: "No coordinates registered",
      },
    },
  },
  sidebar: {
    modules: {
      general: "General",
      monitoring: "Monitoring",
      inspection: "Inspection",
      actionPlan: "Action Plan",
      stabilityAnalysis: "Stability Analysis",
      eor: "Engineer of Record (EoR)",
      ato: "ATO",
      psb: "PSB",
      gistm: "GISTM",
      paebm: "PAEBM",
      damBreakStudy: "Dam Break Study",
      riskAnalysis: "Risk Analysis",
    },
  },
  auth: {
    selectClient: "Select client",
    management: "Management",
    loadingOrganizations: "Loading organizations...",
    errorLoadingOrganizations: "Error loading organizations",
    errorSelectingTenant: "Error selecting organization",
    tryAgain: "Try Again",
    logout: "Logout",
    loading: "Loading...",
    permissionDenied: "You do not have permission",
    pagePermissionDenied: "You do not have permission to access this page.",
    authError:
      "Error verifying authentication. Please try again. If the problem persists contact support",
    permissionError: "Error verifying permissions",
  },
  common: {
    notFoundPage: {
      title: "Page not found",
      description:
        "Sorry, the page you are looking for does not exist or has been moved.",
      backToHome: "Back to home",
      goBack: "Go back",
    },
    tellusAllRightsReserved: "Tellus Company® 2025 All rights reserved",
    error: "Error",
    management: "Management",
    admin: "Admin",
    item: "Item",
    loading: "Loading...",
    deleteModalTitle: "Permanently delete item",
    deleteModalItemMessage: "Item to be deleted:",
    deleteModalAlertMessage:
      " This action is irreversible. Data cannot be recovered after deletion.",
    delete: "Delete",
    deleting: "Deleting...",
    cancel: "Cancel",
    toggleTheme: "Toggle theme",
    deleteSuccess: "Deletion successful",
    createSuccess: "Creation successful",
    editSuccess: "Edit successful",
    errorCreating: "Error creating",
    errorEditing: "Error editing",
    errorDeleting: "Error deleting",
    address: {
      countries: {
        brazil: "Brazil",
      },
      states: {
        acre: "Acre",
        alagoas: "Alagoas",
        amapa: "Amapá",
        amazonas: "Amazonas",
        bahia: "Bahia",
        ceara: "Ceará",
        distritoFederal: "Federal District",
        espiritoSanto: "Espírito Santo",
        goias: "Goiás",
        maranhao: "Maranhão",
        matoGrosso: "Mato Grosso",
        matoGrossoDoSul: "Mato Grosso do Sul",
        minasGerais: "Minas Gerais",
        para: "Pará",
        paraiba: "Paraíba",
        parana: "Paraná",
        pernambuco: "Pernambuco",
        piaui: "Piauí",
        rioDeJaneiro: "Rio de Janeiro",
        rioGrandeDoNorte: "Rio Grande do Norte",
        rioGrandeDoSul: "Rio Grande do Sul",
        rondonia: "Rondônia",
        roraima: "Roraima",
        santaCatarina: "Santa Catarina",
        saoPaulo: "São Paulo",
        sergipe: "Sergipe",
        tocantins: "Tocantins",
      },
    },
  },
  pagination: {
    rowsPerPage: "Rows per page",
    pageOf: "Page {{current}} of {{total}}",
    goToPage: "Go to page",
    goToPageAriaLabel: "Go to page",
    showingRange: "Showing {{start}}–{{end}} of {{total}}",
    showingEmpty: "No records found",
  },
  management: {
    navbar: {
      management: "Management",
      users: "Users",
      clients: "Clients",
      complexes: "Complexes",
      structures: "Structures",
      licenses: "Licenses",
      log: "Log",
      releaseNotes: "Release Notes",
      termsOfUse: "Terms of Use",
      privacyPolicy: "Privacy Policy",
    },
    users: {
      button: {
        new: "New User",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        filter: "Filter",
        clearFilters: "Clear Filters",
      },
      form: {
        label: {
          name: "Name",
          email: "Email",
          role: "Access Type",
          phone: "Phone",
          department: "Department",
          position: "Position",
        },
        placeholder: {
          name: "First Last Name",
          email: "name@company.com",
          roleSelect: "Select...",
          department: "Digital engineering",
          position: "UX/UI Designer",
          filterName: "Enter name",
          filterEmail: "Enter email",
          filterRole: "Select access type...",
        },
      },
      table: {
        column: {
          name: "Name",
          email: "Email",
          role: "Access Type",
        },
        filterButtonText: "Filters",
      },
      modal: {
        title: {
          create: "Create user",
          edit: "Edit user",
        },
      },
      filter: {
        status: {
          active: "Active",
          inactive: "Inactive",
        },
      },
      validation: {
        nameRequired: "Name is required",
        emailInvalid: "Invalid email",
        emailRequired: "Email is required",
        roleRequired: "Access type is required",
        phoneRequired: "Phone is required",
      },
    },
    complexes: {
      button: {
        new: "New Complex",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        filter: "Filter",
        clearFilters: "Clear Filters",
      },
      form: {
        section: {
          generalData: "General Data",
          address: "Address",
          responsible: "Responsible",
        },
        label: {
          cnpj: "CNPJ",
          tradeName: "Exhibition Name",
          companyPhone: "Phone (company)",
          municipalRegistration: "Municipal Registration",
          logo: "Logo",
          zipCode: "ZIP Code",
          street: "Street",
          complement: "Complement",
          neighborhood: "Neighborhood",
          number: "Number",
          city: "City",
          state: "State",
          country: "Country",
          responsibleName: "Name",
          responsibleEmail: "Email",
          responsiblePhone: "Phone (responsible)",
          complex: "Complex",
          phone: "Phone",
          responsible: "Responsible",
        },
        placeholder: {
          cnpj: "00.000.000/0000-00",
          complex: "Complex",
          tradeName: "Exhibition Name",
          companyPhone: "(00) 00000-0000",
          municipalRegistration: "123456789",
          zipCode: "00000-000",
          street: "Street, Avenue, etc",
          complement: "Room, Floor, etc",
          neighborhood: "Neighborhood name",
          number: "123",
          city: "City name",
          state: "Select state",
          country: "Select country",
          responsibleName: "First Last Name",
          responsibleEmail: "name@company.com",
          responsiblePhone: "(00) 00000-0000",
          filterComplex: "Enter complex name",
          filterPhone: "Enter phone",
          filterResponsible: "Enter responsible name",
        },
      },
      table: {
        column: {
          complex: "Complex",
          phone: "Phone",
          responsible: "Responsible",
        },
        filterButtonText: "Filters",
      },
      modal: {
        title: {
          create: "Create complex",
          edit: "Edit complex",
        },
      },
      validation: {
        cnpjRequired: "CNPJ is required",
        cnpjInvalid: "Invalid CNPJ. Expected format: 00.000.000/0000-00",
        companyRequired: "Company is required",
        tradeNameRequired: "Exhibition name is required",
        companyPhoneRequired: "Company phone is required",
        telefoneInvalid: "Invalid phone. Expected format: (00) 00000-0000",
        municipalRegistrationRequired: "Municipal registration is required",
        logoRequired: "Logo is required",
        logoInvalidType: "Logo must be a JPEG, JPG or PNG image",
        zipCodeRequired: "ZIP code is required",
        zipCodeInvalid: "Invalid ZIP code. Expected format: 00000-000",
        streetRequired: "Street is required",
        neighborhoodRequired: "Neighborhood is required",
        numberRequired: "Number is required",
        numberInvalid: "Enter a valid whole number",
        cityRequired: "City is required",
        stateRequired: "State is required",
        countryRequired: "Country is required",
        responsibleNameRequired: "Responsible name is required",
        responsibleEmailRequired: "Responsible email is required",
        emailInvalid: "Invalid email",
        responsiblePhoneRequired: "Responsible phone is required",
      },
    },
    clients: {
      button: {
        new: "New Client",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        filter: "Filter",
        clearFilters: "Clear Filters",
      },
      form: {
        section: {
          generalData: "General Data",
          address: "Address",
          responsible: "Responsible",
        },
        label: {
          cnpj: "CNPJ",
          company: "Company",
          tradeName: "Trade Name",
          companyPhone: "Phone (company)",
          municipalRegistration: "Municipal Registration",
          logo: "Logo",
          zipCode: "ZIP Code",
          street: "Street",
          complement: "Complement",
          neighborhood: "Neighborhood",
          number: "Number",
          city: "City",
          state: "State",
          country: "Country",
          responsibleName: "Name",
          responsibleEmail: "Email",
          responsiblePhone: "Phone (responsible)",
          client: "Client",
          responsible: "Responsible",
        },
        placeholder: {
          cnpj: "00.000.000/0000-00",
          company: "Company name",
          tradeName: "Trade name",
          companyPhone: "(00) 00000-0000",
          municipalRegistration: "123456789",
          zipCode: "00000-000",
          street: "Street, Avenue, etc",
          complement: "Room, Floor, etc",
          neighborhood: "Neighborhood name",
          number: "123",
          city: "City name",
          state: "Select state",
          country: "Select country",
          responsibleName: "First Last Name",
          responsibleEmail: "name@company.com",
          responsiblePhone: "(00) 00000-0000",
          filterClient: "Enter client name",
          filterTradeName: "Enter trade name",
          filterCnpj: "Enter CNPJ",
          filterResponsible: "Enter responsible name",
        },
      },
      table: {
        column: {
          client: "Client",
          tradeName: "Trade Name",
          cnpj: "CNPJ",
          responsible: "Responsible",
        },
        filterButtonText: "Filters",
      },
      modal: {
        title: {
          create: "Create client",
          edit: "Edit client",
        },
      },
      validation: {
        cnpjRequired: "CNPJ is required",
        cnpjInvalid: "Invalid CNPJ. Expected format: 00.000.000/0000-00",
        companyRequired: "Company is required",
        tradeNameRequired: "Trade name is required",
        companyPhoneRequired: "Company phone is required",
        telefoneInvalid: "Invalid phone. Expected format: (00) 00000-0000",
        municipalRegistrationRequired: "Municipal registration is required",
        logoRequired: "Logo is required",
        logoInvalidType: "Logo must be a JPEG, JPG or PNG image",
        zipCodeRequired: "ZIP code is required",
        zipCodeInvalid: "Invalid ZIP code. Expected format: 00000-000",
        streetRequired: "Street is required",
        neighborhoodRequired: "Neighborhood is required",
        numberRequired: "Number is required",
        numberInvalid: "Enter a valid whole number",
        cityRequired: "City is required",
        stateRequired: "State is required",
        countryRequired: "Country is required",
        responsibleNameRequired: "Responsible name is required",
        responsibleEmailRequired: "Responsible email is required",
        emailInvalid: "Invalid email",
        responsiblePhoneRequired: "Responsible phone is required",
      },
    },
    structures: {
      button: {
        new: "New Structure",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        filter: "Filter",
        clearFilters: "Clear Filters",
      },
      form: {
        section: {
          coordinates: "Structure Coordinates",
        },
        label: {
          structure: "Structure",
          name: "Name",
          complex: "Complex",
          complexName: "Complex",
          coordinateSystem: "Coordinate System",
          coordinateE: "Coordinate E",
          coordinateN: "Coordinate N",
          radiusKm: "Radius (Km)",
          client: "Client",
        },
        placeholder: {
          structure: "Structure name",
          coordinateSystem: "Select...",
          coordinateE: "Coordinate E",
          coordinateN: "Coordinate N",
          radiusKm: "0",
          name: "Structure name",
          complexSelect: "Select a complex",
          filterName: "Enter structure name",
          filterComplexName: "Enter complex name",
          filterStructure: "Enter structure name",
          clientSelect: "Select a client",
        },
      },
      table: {
        column: {
          structure: "Structure",
          name: "Name",
          complexName: "Complex",
        },
        filterButtonText: "Filters",
      },
      modal: {
        title: {
          create: "Create structure",
          edit: "Edit structure",
        },
      },
      validation: {
        nameRequired: "Name is required",
        complexRequired: "Complex is required",
        structureRequired: "Structure is required",
        coordinateSystemRequired: "Coordinate system is required",
        coordinateERequired: "Coordinate E is required",
        coordinateNRequired: "Coordinate N is required",
        radiusKmRequired: "Radius (Km) is required",
        radiusKmMustBeNumber: "Radius (Km) must be a number",
      },
    },
    log: {
      page: {
        title: "Logs",
        description: "View system activity and audit logs.",
      },
      button: {
        export: "Export",
      },
      form: {
        label: {
          columns: "Columns",
          startDate: "Start Date",
          endDate: "End Date",
        },
        placeholder: {
          columns: "Select columns...",
          searchColumns: "Search columns...",
          notFound: "No column found",
          notMoreOptions: "No more options",
        },
      },
      columns: {
        user: "User",
        action: "Action",
        date: "Date",
        ip: "IP",
        module: "Module",
      },
      validation: {
        columnsRequired: "Columns are required",
        startDateRequired: "Start date is required",
        endDateRequired: "End date is required",
        dateRangeInvalid: "End date must be on or after start date",
      },
    },
    licenses: {
      button: {
        new: "New License",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        view: "View",
        filter: "Filter",
        clearFilters: "Clear Filters",
      },
      form: {
        label: {
          client: "Client",
          clientEmail: "Client Email",
          managerEmail: "GS3 Manager Email",
          complex: "Complex",
          structure: "Structure",
          module: "Module",
          licenses: "Licenses",
          startDate: "Start date",
          endDate: "End date",
          notificationPeriods: "Notification period",
          days: "days",
          tenant: "Tenant",
        },
        placeholder: {
          client: "Select a client",
          clientEmail: "email@client.com",
          managerEmail: "manager@gs3.com",
          complex: "Select a complex",
          structure: "Select a structure",
          module: "Select a module",
          licenses: "0",
          notificationPeriods: "Add period...",
          filterComplex: "Enter complex name",
          filterStructure: "Enter structure name",
          filterModule: "Select a module",
          filterLicenses: "Enter quantity",
        },
      },
      table: {
        column: {
          complex: "Complex",
          structure: "Structure",
          module: "Module",
          licenses: "Licenses",
          accessPeriod: "Access period",
        },
        filterButtonText: "Filters",
      },
      modal: {
        title: {
          create: "Create license",
          edit: "Edit license",
          view: "License details",
        },
      },
      validation: {
        clientRequired: "Client is required",
        clientEmailRequired: "Client email is required",
        managerEmailRequired: "Manager email is required",
        emailInvalid: "Invalid email",
        complexRequired: "Complex is required",
        structureRequired: "Structure is required",
        moduleRequired: "Module is required",
        licensesRequired: "Licenses is required",
        licensesInvalid: "Enter a valid whole number of licenses",
        startDateRequired: "Start date is required",
        endDateRequired: "End date is required",
        notificationPeriodsMax: "Maximum of 3 notification periods",
        notificationPeriodAlreadyExists: "This period has already been added",
        notificationPeriodsMin: "Add at least 1 notification period",
      },
    },
    releaseNotes: {
      button: {
        addNewVersion: "Add new version",
        save: "Save",
        cancel: "Cancel",
      },
      form: {
        label: {
          file: "File",
          version: "File version",
        },
        placeholder: {
          version: "E.g.: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Add new version",
        },
      },
      validation: {
        fileRequired: "File is required",
        fileInvalidType: "File must be a PDF",
        versionRequired: "Version is required",
      },
    },
    termsOfUse: {
      noFileUploaded: "No file has been uploaded yet",
      button: {
        addNewVersion: "Add new version",
        save: "Save",
        cancel: "Cancel",
      },
      form: {
        label: {
          file: "File",
          version: "File version",
        },
        placeholder: {
          version: "E.g.: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Add new version",
        },
      },
      validation: {
        fileRequired: "File is required",
        fileTooLarge: "File must be at most 20MB",
        fileInvalidType: "File must be a PDF",
      },
    },
    privacyPolicy: {
      noFileUploaded: "No file has been uploaded yet",
      button: {
        addNewVersion: "Add new version",
        save: "Save",
        cancel: "Cancel",
      },
      form: {
        label: {
          file: "File",
          version: "File version",
        },
        placeholder: {
          version: "E.g.: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Add new version",
        },
      },
      validation: {
        fileRequired: "File is required",
        fileTooLarge: "File must be at most 20MB",
        fileInvalidType: "File must be a PDF",
      },
    },
  },
  home: {
    welcome: {
      title: "Welcome to GS3",
      subtitle: "Select a module in the side menu to get started.",
    },
    hero: {
      badge: "System under development",
      tagline: "The future of dam monitoring is coming",
      subtitle:
        "We are building a comprehensive platform for dam safety management and monitoring. Track the progress of each module below.",
    },
    modules: {
      title: "System Modules",
      badgeActive: "In development",
      badgeSoon: "Coming soon",
      badgeCompleted: "Completed",
      progress: "Progress",
      authenticationAndSecurity: {
        name: "Authentication and Security",
        description:
          "Authentication, authorization and user management modules",
      },
      administrative: {
        name: "Administrative",
        description: "Administrative features by Admin users",
      },
      general: { name: "General", description: "System overview" },
      monitoring: {
        name: "Monitoring",
        description: "Continuous instrument monitoring",
      },
      inspections: {
        name: "Inspections",
        description: "Field inspection records and management",
      },
      actionPlan: {
        name: "Action Plan",
        description: "Action plans and activity tracking",
      },
      stability: {
        name: "Stability",
        description: "Slope stability analysis",
      },
      eor: { name: "EoR", description: "Dam classification and framework" },
      ato: {
        name: "ATO",
        description: "Structure operation authorization",
      },
      psb: { name: "PSB", description: "Dam safety plan" },
      gistm: {
        name: "GISTM",
        description: "Global tailings management standard",
      },
      paebm: { name: "PAEBM", description: "Emergency action plan" },
      damBreak: {
        name: "Dam Break",
        description: "Break simulation and self-rescue zones",
      },
      riskAnalysis: {
        name: "Risk Analysis",
        description: "Risk assessment and classification",
      },
      report: { name: "Report", description: "Technical report generation" },
      dashboard: {
        name: "Dashboard",
        description: "KPI panels and metrics",
      },
      cmg: { name: "CMG", description: "Maintenance and control management" },
      managerial: {
        name: "Management",
        description: "User, client and license management",
      },
    },
    map: {
      title: "Monitored coverage area",
    },
  },
  legalDocuments: {
    modal: {
      version: "Version",
      accept: "Accept",
      termsOfUse: {
        title: "Terms of Use",
        readConfirm: "I have read and accept the Terms of Use",
      },
      privacyPolicy: {
        title: "Privacy Policy",
        readConfirm: "I have read and accept the Privacy Policy",
      },
    },
  },
  errors: {
    errorFallback: "Unexpected error",
    error1: "Invalid request. Refresh the page and try again",
    error2: "User not found",
    error3: "Your session has expired. Please log in again",
    error4: "Select an organization to continue",
    error5: "Selected organization is not available",
    error6: "You do not have access to this organization",
    error7: "Session expired. Please log in again",
    error8: "Your session has expired. Please log in again",
    error9:
      "Could not validate your device. Refresh the page and try again",
    error10: "Could not complete. Refresh the page and try again",
    error11:
      "This organization is not yet available. Try again later or contact support",
    error12: "You do not have permission for this action",
    error13: "A user with this email already exists",
    error14: "An environment with this CNPJ already exists",
    error15: "File type not allowed",
    error16: "File too large (maximum 20 MB)",
    error17: "File upload is required",
    error18: "Legal document not found",
    error19: "You have already accepted this document",
    error20: "A complex with this CNPJ already exists",
    error21: "Complex not found",
    error22:
      "A structure with this name already exists for the selected complex",
    error23: "Structure not found",
    error24: "Selected module is not available",
    error25: "The structure already has an active license for this module",
    error26: "License not found",
    error27: "Access denied",
    error28: "Resource not found",
    error29:
      "This user cannot be promoted to Super Admin (already has an administrative role)",
    error30: "This user is not a Super Admin",
    error31: "This user is already an admin of this complex",
    error32:
      "License capacity exhausted. Revoke an existing allocation or expand your plan",
    error33: "This user already has this license assigned",
    error34:
      "Cannot edit permissions for this user (administrative role)",
    error35: "This module is not available in the selected structure",
    error36: "Selected module is invalid for this context",
    error37: "One or more selected permissions do not exist for this module",
    error38: "This user role cannot receive license allocations",
    error54: "Fill in all required raising history fields before saving",
    error55:
      "Review the raising history data: elevation must be a number (e.g. 845.25), the date must be valid, and the method must be from the list",
    error56: "Raising history entry not found",
    error77: "Inspection not found",
    error78: "Inspection participant not found",
    error79: "Invalid filters or pagination. Adjust the criteria and try again",
    error80: "Could not save. Review the inspection form and try again",
    error81: "This inspection cannot be changed in its current state",
    error82: "This inspection cannot be deleted",
    error83: "This inspection cannot be finalized now",
    error84: "The date of a scheduled inspection cannot be changed",
    error85:
      "Complete the form and the required evidence before finalizing",
    error86: "All participants must sign before finalizing",
    error87: "This participant cannot be removed",
    error88:
      "Could not upload the photo. Check the file type and the inspection state",
    error89: "Invalid signature font. Choose one of the available fonts",
    error90:
      "Could not generate the PDF. The inspection remains in progress. Try finalizing again",
    error91: "The PDF report is not available yet",
    error92: "Enter a valid inspection date (it cannot be in the future)",
    error93:
      "The name of a registered system participant cannot be changed on this form",
    error94: "A scheduled inspection can only be edited on its planned day",
    error97: "This participant is already on the inspection",
    error98: "Invalid request. Refresh the page and try again",
    error99: "Invalid request. Refresh the page and try again",
    error100:
      "That language is not valid. Choose a language from the menu and try again",
    error101: "That theme is not valid. Refresh the page and try again",
    boundary: {
      network: {
        title: "Connection error",
        message: "Could not connect to the server.",
        suggestion: "Check your internet connection and try again.",
      },
      unexpected: {
        title: "Unexpected error",
        message: "An unexpected error occurred. Please try again.",
        suggestion: "If the problem persists, please contact support.",
      },
      unknown: {
        title: "Unknown error",
        message: "An unexpected error occurred.",
        suggestion: "Try reloading the page.",
      },
      unauthorized: {
        title: "Not authenticated",
        message: "You need to log in to access this page.",
        suggestion: "Please log in and try again.",
      },
      forbidden: {
        title: "Access denied",
        message: "You do not have permission to access this resource.",
        suggestion: "Contact the administrator if you need access.",
      },
      notFound: {
        title: "Page not found",
        message: "The page you are looking for does not exist.",
        suggestion: "Check the address or go back to the home page.",
      },
      serverError: {
        title: "Server error",
        message: "An internal server error occurred.",
        suggestion: "Please try again in a few moments.",
      },
      serviceUnavailable: {
        title: "Service unavailable",
        message: "The server is temporarily unavailable.",
        suggestion:
          "We are working to resolve this. Please try again soon.",
      },
      default: {
        title: "Error",
        message: "An unexpected error occurred.",
      },
    },
    appBoundary: {
      title: "Something went wrong",
      description: "An unexpected error occurred. Please try again.",
      details: "Error Details:",
      stackTrace: "Stack Trace",
      retry: "Try Again",
      reload: "Reload Page",
      goHome: "Go to home",
    },
  },
  admin: {
    tabs: {
      users: "Users",
      access: "Access",
      complexes: "Complexes",
      structures: "Structures",
      licenseInventory: "Licenses",
      licenseAssignments: "Assignments",
      permissions: "Permissions",
    },
    access: {
      page: {
        title: "Access",
        subtitle:
          "Manage which users are admins of specific complexes.",
      },
      complexAdmins: {
        sectionTitle: "Complex Admins",
        sectionDescription:
          "Complex Admins have permissions within a specific complex. Only Owner can assign.",
        button: {
          assign: "Assign complex admin",
          remove: "Remove",
        },
        filter: {
          allComplexes: "All complexes",
          complexLabel: "Filter by complex",
        },
        modal: {
          assignTitle: "Assign complex admin",
          removeTitle: "Remove complex admin",
          removeMessage:
            "Are you sure you want to remove this assignment? The user will no longer administer this complex.",
        },
        table: {
          filterButtonText: "Filters",
          column: {
            user: "User",
            email: "Email",
            complex: "Complex",
            createdAt: "Assigned at",
          },
          empty: "No assignments registered.",
        },
      },
      form: {
        label: {
          user: "User",
          complex: "Complex",
        },
        placeholder: {
          selectUser: "Select a user...",
          selectComplex: "Select a complex...",
        },
        validation: {
          userRequired: "Select a user",
          complexRequired: "Select a complex",
        },
        empty: {
          eligibleUsers:
            "No eligible users available.",
        },
      },
      forbidden: "You do not have permission to view this tab.",
    },
    complexes: {
      page: {
        title: "Complexes",
        subtitle: "View the complexes available in your tenant.",
      },
      button: {
        viewDetails: "View details",
        close: "Close",
        filter: "Filter",
        clearFilters: "Clear Filters",
      },
      table: {
        filterButtonText: "Filters",
        column: {
          name: "Name",
          fantasyName: "Trade Name",
          cnpj: "CNPJ",
          responsibleName: "Responsible",
        },
      },
      filter: {
        label: {
          name: "Name",
          fantasyName: "Trade Name",
          cnpj: "CNPJ",
          responsibleName: "Responsible",
        },
        placeholder: {
          name: "Type the name",
          fantasyName: "Type the trade name",
          cnpj: "Type the CNPJ",
          responsibleName: "Type the responsible name",
        },
      },
      details: {
        title: "Complex details",
        section: {
          identification: "Identification",
          contact: "Contact",
          address: "Address",
        },
        label: {
          name: "Name",
          fantasyName: "Trade Name",
          cnpj: "CNPJ",
          municipalRegistration: "Municipal Registration",
          complexPhone: "Complex phone",
          responsibleName: "Responsible",
          responsiblePhone: "Phone",
          phone: "Phone",
          zipCode: "ZIP Code",
          street: "Street",
          number: "Number",
          complement: "Complement",
          neighborhood: "Neighborhood",
          city: "City",
          state: "State",
          country: "Country",
        },
        empty: "No address information.",
        notProvided: "—",
        loadError: "Error loading complex details.",
      },
    },
    structures: {
      page: {
        title: "Structures",
        subtitle:
          "View the structures of each complex. Select a complex to start.",
      },
      complexSelector: {
        label: "Complex",
        placeholder: "Select a complex...",
        empty: "Select a complex above to view structures.",
      },
      table: {
        filterButtonText: "Filters",
        column: {
          name: "Name",
          type: "Type",
          operationalStatus: "Operational status",
          coordinateX: "Coordinate X",
          coordinateY: "Coordinate Y",
          actions: "Actions",
        },
        action: {
          details: "Details",
        },
      },
      filter: {
        label: {
          name: "Name",
          type: "Type",
          operationalStatus: "Operational status",
        },
        placeholder: {
          name: "Type the name",
          type: "Select the type",
          operationalStatus: "Select the status",
        },
        button: {
          filter: "Filter",
          clearFilters: "Clear Filters",
        },
      },
      structureType: {
        dam: "Dam",
        stockpile: "Stockpile",
        openPit: "Open pit",
      },
      operationalStatus: {
        decommissioned: "Decommissioned",
        underConstruction: "Under construction",
        inOperation: "In operation",
        underConstructionAndOperation: "Under construction/operation",
        underDecommissioning: "Under decommissioning",
        halted: "Halted",
      },
      modal: {
        title: "Register structure data",
        button: {
          close: "Close",
          cancel: "Cancel",
          save: "Save",
        },
        tab: {
          generalData: "General data",
          raisingHistory: "Raising history",
          geometryDam: "Embankment geometry",
          geometry: "Geometry",
          hydrology: "Hydrology",
          reservoirManagement: "Reservoir management",
          anmClassification: "ANM classification",
          regionalClassification: "Regional classification",
          riskMapping: "Risk mapping",
        },
      },
      generalData: {
        label: {
          name: "Name",
          type: "Type",
          responsibleCompany: "Responsible company",
          operationalStatus: "Operational status",
          operationStartDate: "Operation start",
          operationEndDate: "Operation end",
          centralPointSystem: "Coordinate system",
          centralPointE: "E coordinate",
          centralPointN: "N coordinate",
          pinSystem: "Coordinate system",
          pinE: "E coordinate",
          pinN: "N coordinate",
          utmEnabled: "UTM",
          utmZone: "UTM zone",
          utmHemisphere: "Hemisphere",
          orthophoto: "Orthophoto",
        },
        section: {
          centralPointDam: "Central crest point coordinates",
          centralPointTop: "Central top point coordinates",
          pin: "Pin coordinates",
          pinInfoTooltip:
            "Optional coordinates used only to center the map on the structure. When the official central point coordinates don't visually land at the center, the pin adjusts the map marker without changing registry data.",
          pinInfoAriaLabel: "Information about pin coordinates",
        },
        coordinateSystem: {
          sirgas2000: "SIRGAS2000",
          astrochua: "ASTROCHUA",
          corregoAlegre: "CORREGO ALEGRE",
          sad69: "SAD69",
          wgs84: "WGS84",
        },
        utmHemisphere: {
          north: "North",
          south: "South",
        },
        button: {
          uploadOrthophoto: "Upload orthophoto",
        },
        placeholder: {
          type: "Select the type",
          orthophoto: "Select a .tif file",
        },
        validation: {
          typeRequired: "Select the structure type",
          responsibleCompanyRequired: "Enter the responsible company",
          operationalStatusRequired: "Select the operational status",
          operationStartDateRequired: "Enter the operation start date",
          centralPointSystemRequired:
            "Select the central point coordinate system",
          centralPointERequired: "Enter the central point E coordinate",
          centralPointNRequired: "Enter the central point N coordinate",
          pinGroupIncomplete:
            "Fill all pin fields or leave the entire group empty",
          utmZoneRequired: "Enter the UTM zone",
          utmHemisphereRequired: "Select the UTM hemisphere",
          utmZoneOutOfRange: "UTM zone must be between 1 and 60",
          formInvalidTitle: "Fill in the required fields",
          formInvalidDescription:
            "Fix the highlighted fields below before saving.",
          decimalInvalid:
            "Enter a valid number (use a dot or comma as the decimal separator)",
        },
      },
      geometry: {
        label: {
          crestElevation: "Crest elevation (m)",
          damHeight: "Dam height (m)",
          crestLength: "Crest length (m)",
          crestWidth: "Crest width (m)",
          typicalBermWidth: "Typical berm width (m)",
          upstreamSlopeInclination: "Upstream slope inclination (°)",
          downstreamSlopeInclination: "Downstream slope inclination (°)",
          betweenBermsSlopeInclination: "Between-berms slope inclination (°)",
          globalDownstreamSlopeInclination: "Global downstream slope inclination (°)",
          benchSlopeInclination: "Bench slope inclination (°)",
          globalSlopeInclination: "Global slope inclination (°)",
          pitHeight: "Height (m)",
          sectors: "Sectors",
          benchHeight: "Bench height (m)",
          benchInclination: "Bench inclination (°)",
          referenceDocument: "Reference document",
        },
        validation: {
          crestElevationRequired: "Enter the crest elevation",
          damHeightRequired: "Enter the dam height",
          crestLengthRequired: "Enter the crest length",
          crestWidthRequired: "Enter the crest width",
          typicalBermWidthRequired: "Enter the typical berm width",
          upstreamSlopeInclinationRequired: "Enter the upstream slope inclination",
          downstreamSlopeInclinationRequired: "Enter the downstream slope inclination",
          betweenBermsSlopeInclinationRequired:
            "Enter the between-berms slope inclination",
          globalDownstreamSlopeInclinationRequired:
            "Enter the global downstream slope inclination",
          benchSlopeInclinationRequired: "Enter the bench slope inclination",
          globalSlopeInclinationRequired: "Enter the global slope inclination",
          sectorsRequired: "Enter the number of sectors",
          sectorsInvalid: "Enter a whole number greater than or equal to zero",
          pitHeightRequired: "Enter the height",
          benchHeightRequired: "Enter the bench height",
          benchInclinationRequired: "Enter the bench inclination",
          referenceDocumentRequired: "Enter the reference document",
          decimalInvalid:
            "Enter a valid number (use a dot or comma as the decimal separator)",
        },
      },
      raisingHistory: {
        label: {
          raisingCount: "Number of raisings",
          executiveProjectDesigner: "Executive project (designer)",
          stage: "Stage",
          method: "Method",
          elevation: "Elevation (m)",
          elevationShort: "Elevation",
          occurredOn: "Date",
        },
        method: {
          downstream: "Downstream",
          upstream: "Upstream",
          centerLine: "Center line",
        },
        button: {
          register: "Register",
          edit: "Edit",
          delete: "Delete",
          confirm: "Confirm",
        },
        table: {
          filterButtonText: "Filter",
        },
        filter: {
          label: {
            stage: "Stage",
            method: "Method",
          },
          placeholder: {
            stage: "Filter by stage",
            method: "Filter by method",
          },
          button: {
            clearFilters: "Clear filters",
          },
        },
        modal: {
          createTitle: "New raising",
          editTitle: "Edit raising",
          deleteTitle: "Delete raising",
          deleteMessage: "Do you want to delete this raising?",
        },
        validation: {
          executiveProjectDesignerRequired:
            "Enter the executive project (designer)",
          stageRequired: "Enter the stage",
          methodRequired: "Select the method",
          elevationRequired: "Enter the elevation",
          elevationInvalid:
            "Enter elevation in meters using numbers only (e.g. 845.25)",
          occurredOnRequired: "Enter the date",
          occurredOnInvalid: "Enter a valid date",
        },
      },
      reservoirManagement: {
        label: {
          occupiedArea: "Reservoir occupied area (m²)",
          occupiedAreaShort: "Occupied area (m²)",
          totalVolume: "Total reservoir volume (m³)",
          totalVolumeShort: "Total vol. (m³)",
          totalOccupiedVolume: "Total occupied volume (m³)",
          totalOccupiedVolumeShort: "Total occupied vol. (m³)",
          availableVolume: "Available volume (m³)",
          availableVolumeShort: "Available vol. (m³)",
          rejectOccupiedVolume: "Reject occupied volume (m³)",
          rejectOccupiedVolumeShort: "Reject occupied vol. (m³)",
          waterOccupiedVolume: "Water occupied volume (m³)",
          waterOccupiedVolumeShort: "Water occupied vol. (m³)",
          waterLevel: "Water level",
          recordedOn: "Date",
        },
        button: {
          register: "Register",
          edit: "Edit",
          delete: "Delete",
          confirm: "Confirm",
        },
        table: {
          filterButtonText: "Filter",
        },
        filter: {
          label: {
            recordedOn: "Date",
          },
          button: {
            clearFilters: "Clear filters",
          },
        },
        modal: {
          createTitle: "New management",
          editTitle: "Edit management",
          deleteTitle: "Delete management",
          deleteMessage: "Do you want to delete this management record?",
        },
        validation: {
          occupiedAreaRequired: "Enter the reservoir occupied area",
          occupiedAreaInvalid: "Enter the occupied area using numbers only",
          totalVolumeRequired: "Enter the total reservoir volume",
          totalVolumeInvalid: "Enter the total volume using numbers only",
          totalOccupiedVolumeRequired: "Enter the total occupied volume",
          totalOccupiedVolumeInvalid:
            "Enter the total occupied volume using numbers only",
          availableVolumeRequired: "Enter the available volume",
          availableVolumeInvalid:
            "Enter the available volume using numbers only",
          rejectOccupiedVolumeRequired: "Enter the reject occupied volume",
          rejectOccupiedVolumeInvalid:
            "Enter the reject occupied volume using numbers only",
          waterOccupiedVolumeRequired: "Enter the water occupied volume",
          waterOccupiedVolumeInvalid:
            "Enter the water occupied volume using numbers only",
          waterLevelRequired: "Enter the water level",
          waterLevelInvalid: "Enter the water level using numbers only",
          recordedOnRequired: "Enter the date",
          recordedOnInvalid: "Enter a valid date",
        },
      },
      anmClassification: {
        classification: {
          high: "High",
          medium: "Medium",
          low: "Low",
        },
        label: {
          criBignumberTitle: "Risk classification (CRI)",
          dpaBignumberTitle: "Associated potential damage (DPA)",
          goBignumberTitle: "Operational management (GO)",
          referenceDocButton: "Reference documentation {{section}}",
          referenceDocPanel: "Reference documentation — {{section}}",
          close: "Close",
          total: "Total {{section}}",
          classificationStatus: "Classification {{section}}",
          partial: "Partial {{grade}}",
          points: "Points",
          classification: "Classification",
          criterion: "Criterion",
          band: "Band",
          riskCategory: "Risk category",
          riskCategoryCri: "Risk category (CRI)",
        },
        criPanel: {
          tableTitle: "Table 1 - Classification for mining dams",
          ctRow: "Technical characteristics (CT)",
          ecRow: "Conservation condition (EC)",
          psRow: "Dam safety plan (PS)",
          totalFormula: "Total score (CRI) = CT + EC + PS",
          riskClassification: "Risk classification",
          bandsTitle: "Classification bands",
          bandHigh: ">= 80 or EC = 10 (*)",
          bandMedium: "40 < CRI < 80",
          bandLow: "<= 40",
          footnote:
            "(*) A score of (10) in any conservation condition (EC) column automatically implies HIGH RISK CATEGORY and the need for immediate precautions by the dam owner",
        },
        dpaPanel: {
          tableTitle: "Classification for mining dams",
          damageCategoryDpa: "Associated potential damage (DPA)",
          volumeRow: "Total reservoir volume",
          populationRow: "Existence of downstream population",
          environmentalRow: "Environmental impact",
          socioeconomicRow: "Socioeconomic impact",
          totalLabel: "Total score (DPA)",
          damageClassification: "Damage classification",
          bandsTitle: "Classification bands",
          damageCategory: "Associated potential damage",
          bandHigh: ">= 13",
          bandMedium: "7 < DPA < 13",
          bandLow: "<= 7",
          matrixFooter: "Classification matrix",
        },
        goClassification: {
          aa: "AA",
          a: "A",
          b: "B",
          c: "C",
          d: "D",
        },
        goPanel: {
          tableTitle: "Table 6 - Classification regarding operational management",
          operationalCategory: "Operational management (GO)",
          risrRow: "RISR stability condition declaration submitted",
          rpsbRow: "RPSB stability condition declaration submitted",
          conformityRow: "Conformity and operationality declaration submitted",
          inspectionRow: "Inspection summary submitted",
          edrRow: "Existence of Engineer of Record (EdR)",
          pgrbmRow: "Risk Management Program for Mining Dams — PGRBM",
          certificationRow: "Industry certification and/or standards",
          totalLabel: "Total score (GO)",
          operationalClassification: "Operational management classification",
          bandsTitle: "Classification bands",
          gopCategory: "GOP",
          bandAa: "0",
          bandA: "1 to 7",
          bandB: "8 to 35",
          bandC: "36 to 59",
          bandD: ">= 60 (*)",
          footnote:
            "(*) A dam that should be registered in CNBM but is discovered during an enforcement action will remain in class D for the subsequent 6 months.",
        },
        validation: {
          incompleteSelectionTitle: "Incomplete selection",
          incompleteSelectionDescription:
            "Select one card in each column of every grade (CRI, DPA, and Operational management) before saving.",
        },
        catalog: anmClassificationCatalogEnUS,
      },
      regionalClassification: {
        classification: {
          high: "High",
          medium: "Medium",
          low: "Low",
        },
        state: {
          label: "State",
          placeholder: "Select the state",
          mg: "Minas Gerais",
        },
        norm: {
          label: "Norm",
          placeholder: "Select the norm",
          locked: "Norm locked after the first save.",
        },
        label: {
          criBignumberTitle: "Risk category (CRI)",
          secondBignumberTitle: "Potential damage",
          referenceDocButton: "Reference documentation {{section}}",
          referenceDocPanel: "Reference documentation — {{section}}",
          close: "Close",
          total: "Total {{section}}",
          classificationStatus: "Classification {{section}}",
          partial: "Partial {{grade}}",
          points: "Points",
          classification: "Classification",
          criterion: "Criterion",
          band: "Band",
          riskCategory: "Risk category",
          riskCategoryCri: "Risk category (CRI)",
        },
        criPanel: {
          sectionRowNumber: "1",
          gradeRowNumber: "1.{{index}}",
          totalFormula: "Total score (CRI) = CT + EC + PSB",
          bandsTitle: "Classification bands",
          bandHigh: ">= {{highMin}} or EC = {{ecScore}} (*)",
          bandMedium: "{{mediumMin}} < CRI < {{highMin}}",
          bandLow: "<= {{mediumMin}}",
          footnote:
            "(*) A score of ({{ecScore}}) or higher in any state of conservation (EC) column automatically implies HIGH risk category and requires immediate preventive measures by the dam owner",
        },
        secondPanel: {
          sectionRowNumber: "2",
          criterionRowNumber: "2.{{index}}",
          damageCategory: "Associated potential damage ({{section}})",
          totalLabel: "Total score ({{section}})",
          damageClassification: "Damage classification",
          bandsTitle: "Classification bands",
          bandHigh: ">= {{highMin}}",
          bandMedium: "{{mediumMin}} < {{section}} < {{highMin}}",
          bandLow: "<= {{mediumMin}}",
          matrixFooter: "Classification matrix",
        },
        validation: {
          incompleteSelectionTitle: "Incomplete selection",
          incompleteSelectionDescription:
            "Select one card in each column of all grids (CRI and PDA/DPA) before saving.",
          stateRequired: "Select the state",
          normRequired: "Select the norm",
          normLocked: "The norm cannot be changed after the first save.",
        },
        catalog: regionalClassificationCatalogEnUS,
      },
      riskMapping: {
        label: {
          wasteType: "Waste type",
          downstreamHumanOccupation: "Human occupation downstream of the dam",
          downstreamEnvironmentalInterest:
            "Environmental interest in the area downstream of the dam",
          downstreamInstallation:
            "Installation in the area downstream of the dam",
        },
        validation: {
          wasteTypeRequired: "Enter the waste type",
          downstreamHumanOccupationRequired:
            "Enter human occupation downstream of the dam",
          downstreamEnvironmentalInterestRequired:
            "Enter environmental interest downstream of the dam",
          downstreamInstallationRequired:
            "Enter installation downstream of the dam",
        },
      },
      hydrology: {
        label: {
          maximumMaximorumLevel: "Maximum maximorum level (m)",
          criticalDuration: "Critical duration (h)",
          inflowRate: "Inflow rate (m³/s)",
          outflowRate: "Outflow rate (m³/s)",
          designRainfall: "Design rainfall (mm)",
          contributingBasinArea: "Contributing basin area (km²)",
          returnPeriod: "Return period (years)",
          totalVolumeAtCrestElevation: "Total volume at crest elevation (m³)",
          spillwayType: "Spillway type",
          spillwaySill: "Spillway sill (mm)",
          referenceDocument: "Reference document",
        },
        spillwayType: {
          surface: "Surface",
          tulip: "Tulip",
          lateralChannel: "Lateral channel",
          labyrinth: "Labyrinth",
          gated: "Gated",
          bottom: "Bottom",
        },
        validation: {
          maximumMaximorumLevelRequired: "Enter the maximum maximorum level",
          criticalDurationRequired: "Enter the critical duration",
          inflowRateRequired: "Enter the inflow rate",
          outflowRateRequired: "Enter the outflow rate",
          designRainfallRequired: "Enter the design rainfall",
          contributingBasinAreaRequired: "Enter the contributing basin area",
          returnPeriodRequired: "Enter the return period",
          totalVolumeAtCrestElevationRequired:
            "Enter the total volume at crest elevation",
          spillwayTypeRequired: "Select the spillway type",
          spillwaySillRequired: "Enter the spillway sill",
          referenceDocumentRequired: "Enter the reference document",
          decimalInvalid:
            "Enter a valid number (use a dot or comma as the decimal separator)",
        },
      },
    },
    users: {
      button: {
        new: "New User",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        filter: "Filter",
        clearFilters: "Clear Filters",
      },
      form: {
        label: {
          name: "Name",
          email: "Email",
          phone: "Phone",
          department: "Department",
          position: "Position",
          userType: "User type",
        },
        placeholder: {
          name: "First Last",
          email: "name@company.com",
          emailTellus: "first.last@telluscompany.com.br",
          userTypeSelect: "Select...",
          department: "Digital Engineering",
          position: "UX/UI Designer",
          filterName: "Type the name",
          filterEmail: "Type the email",
        },
      },
      table: {
        filterButtonText: "Filters",
        column: {
          name: "Name",
          email: "Email",
          role: "Access Type",
          userType: "Type",
          department: "Department",
          position: "Position",
        },
      },
      modal: {
        title: {
          create: "Create user",
          edit: "Edit user",
        },
      },
      userType: {
        client: "Client",
        tellus: "Tellus",
      },
      validation: {
        nameRequired: "Name is required (minimum 2 characters)",
        emailRequired: "Email is required",
        emailInvalid: "Invalid email",
        emailTellusDomain: "Email must belong to the @telluscompany.com.br domain",
        phoneRequired: "Phone is required (minimum 8 characters)",
      },
    },
    licenseInventory: {
      page: {
        title: "License inventory",
        subtitle:
          "View contracted licenses by complex, structure and module, with total, used and available quantities.",
      },
      table: {
        filterButtonText: "Filters",
        column: {
          complex: "Complex",
          structure: "Structure",
          module: "Module",
          validity: "Validity",
          quantity: "Total",
          used: "Used",
          available: "Available",
        },
      },
      filter: {
        label: {
          complex: "Complex",
          structure: "Structure",
          module: "Module",
          onlyActive: "Only active licenses",
        },
        placeholder: {
          complex: "Type the complex name",
          structure: "Type the structure name",
          module: "Type the module name",
        },
        button: {
          filter: "Filter",
          clearFilters: "Clear Filters",
        },
      },
    },
    licenseAssignments: {
      page: {
        title: "License assignments",
        subtitle:
          "Assign and revoke licenses for tenant users. Each assignment consumes one unit of the contracted quantity.",
      },
      button: {
        assign: "Assign license",
        revoke: "Revoke",
      },
      table: {
        filterButtonText: "Filters",
        column: {
          assigneeName: "User",
          assigneeEmail: "Email",
          complex: "Complex",
          structure: "Structure",
          module: "Module",
          validity: "Validity",
        },
      },
      filter: {
        label: {
          complex: "Complex",
          structure: "Structure",
          module: "Module",
          user: "User",
        },
        placeholder: {
          complex: "Type the complex name",
          structure: "Type the structure name",
          module: "Type the module name",
          user: "Type the user name",
        },
        button: {
          filter: "Filter",
          clearFilters: "Clear Filters",
        },
      },
      modal: {
        assignTitle: "Assign license",
        revokeTitle: "Revoke assignment",
        revokeMessage:
          "Are you sure you want to revoke this assignment? The license will become available again.",
      },
      form: {
        label: {
          user: "User",
          license: "License (complex / structure / module)",
        },
        placeholder: {
          selectUser: "Select a user...",
          selectLicense: "Select a license...",
        },
        validation: {
          userRequired: "Select a user",
          licenseRequired: "Select a license",
        },
        licenseOption: {
          available: "available",
        },
        licenseEmpty: "No active license available.",
      },
    },
    permissions: {
      page: {
        title: "Granular permissions",
        subtitle:
          "Define, for each user, which actions they can perform on each module of a specific structure.",
      },
      form: {
        label: {
          complex: "Complex",
          structure: "Structure",
          user: "User",
        },
        placeholder: {
          selectComplex: "Select a complex...",
          selectStructure: "Select a structure...",
          selectUser: "Select a user...",
        },
      },
      empty: {
        selectAll: "Select complex, structure and user to continue.",
      },
      error: {
        load: "Error loading permissions. Make sure you have access to the selected complex.",
      },
      grid: {
        empty: "No modules available for this combination.",
        badge: {
          unavailable: "Unavailable in this structure",
        },
        module: {
          noKeys: "No permission key defined for this module.",
        },
      },
      button: {
        save: "Save permissions",
      },
    },
  },
};
